import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import "react-phone-input-2/lib/material.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { BrowserRouter } from "react-router-dom";
import { Provider } from "react-redux";
import { store } from "./store/store";
import { CountryProvider } from "./context/CountryContext";
import { HomeDataProvider } from "./context/HomeDataContext";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { setLogoutHandler } from "./services/api";
import { Logout } from "./store/actions/AuthActions";

// Inject logout into API service
setLogoutHandler(() => {
  store.dispatch(Logout());
});

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 1000 * 60 * 60 * 24, // 24 hours - data won't be refetched unless cache is invalidated
      gcTime: 1000 * 60 * 60 * 24, // Keep in garbage collection for 24 hours
      refetchOnWindowFocus: false, // Prevent refetching when switching tabs
      retry: false, // Disable retries to prevent "double calls" on failure
    },
  },
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <Provider store={store}>
      <QueryClientProvider client={queryClient}>
        <BrowserRouter basename="/">
          <CountryProvider>
            <HomeDataProvider>
              <App />
            </HomeDataProvider>
          </CountryProvider>
        </BrowserRouter>
      </QueryClientProvider>
    </Provider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
